import { useState } from "react";
import { FileText, ChevronDown, ChevronUp, ShieldCheck, ExternalLink } from "lucide-react";

const CAT_LABEL = {
  wet: "Wetgeving", cao: "Cao", functiehandboek: "Functiehandboek", wor: "WOR", extern: "Extern",
};
const CAT_CLS = {
  wet: "bg-slate-900 text-white", cao: "bg-blue-600 text-white",
  functiehandboek: "bg-teal-600 text-white", wor: "bg-indigo-600 text-white",
  extern: "bg-slate-400 text-white",
};

export const CitationCard = ({ citation, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={`citation-card-${index}`} className="bg-slate-50 border border-slate-200 rounded-md p-4 relative overflow-hidden">
      <div className="flex justify-between items-start mb-2 border-b border-slate-200 pb-2 gap-2">
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded ${CAT_CLS[citation.broncategorie] || "bg-slate-400 text-white"}`}>
              {CAT_LABEL[citation.broncategorie] || citation.broncategorie}
            </span>
            <span className="text-[10px] text-slate-500 flex items-center gap-1">
              <ShieldCheck className="w-3 h-3" /> prioriteit {citation.bronprioriteit}
            </span>
          </div>
          <p className="text-sm font-semibold text-slate-900 mt-1 flex items-center gap-1.5">
            <FileText className="w-3.5 h-3.5 shrink-0" />
            {citation.bron_url ? (
              <a data-testid={`citation-bron-link-${index}`} href={citation.bron_url}
                target="_blank" rel="noopener noreferrer" title="Opent in een nieuw tabblad"
                className="hover:underline inline-flex items-center gap-1 min-w-0">
                {citation.documentnaam} <ExternalLink className="w-3 h-3 shrink-0 text-slate-400" />
              </a>
            ) : citation.documentnaam}
          </p>
          <p className="text-xs text-slate-500 mt-0.5">
            {citation.hoofdstuk} · {citation.artikelnummer}
            {citation.paginanummer ? ` · p. ${citation.paginanummer}` : ""}
          </p>
          <p className="text-[11px] text-slate-400 mt-0.5">Gebruikte versie: {citation.versie}</p>
        </div>
        <button
          data-testid={`toon-bron-btn-${index}`}
          onClick={() => setOpen((o) => !o)}
          className="shrink-0 inline-flex items-center gap-1 text-xs font-medium text-slate-700 hover:text-slate-900 border border-slate-300 rounded-md px-2.5 py-1.5 bg-white hover:bg-slate-50 transition-colors"
        >
          Toon bron {open ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
        </button>
      </div>
      {open && (
        <p data-testid={`bron-tekst-${index}`} className="text-sm text-slate-700 font-mono leading-relaxed border-l-4 border-slate-900 pl-4 mt-2 animate-fade-up">
          {citation.tekst}
        </p>
      )}
    </div>
  );
};
